import AxiosConfig from '@/config/axios-config'

export const ResumoAPI = {

  registrarDownload (resumoId) {
    return AxiosConfig.secureJalekoAPI().post('/resumo_user', { resumo: resumoId, acessos: 1 }).then(response => response.data)
  }

}

export default ResumoAPI
